import { render, staticRenderFns } from "./Glue.vue?vue&type=template&id=20e2921a&"
import script from "./Glue.vue?vue&type=script&lang=js&"
export * from "./Glue.vue?vue&type=script&lang=js&"
import style0 from "./Glue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports